import { IApplicationState, TBoardId, TCardId } from '../../../../types/types';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';

export const getBoardUserMetaRecentCards = (
    state: IApplicationState,
    boardId: TBoardId,
): TCardId[] => {
    const userBoardMeta = getBoardUserMeta(state, boardId);
    return userBoardMeta && userBoardMeta.recentCards || [];
};
